import React from 'react';
import { RenderPage } from '@/src/render';
import styled from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/src/store/configure';
import { CustomeWidgets } from './components/CustomWidgets';


const Container = styled.div`
  width: 100%;
`;


RenderPage(
  'csr-stock-details-widgets',
  <Provider store={store}>
    <BrowserRouter>
      <Container>
         <CustomeWidgets />
      </Container>
    </BrowserRouter>
  </Provider>,
);
